import { logoutService, userDetailsService } from '@/api/services/auth/authService'
import Cookies from 'js-cookie'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface User {
  id: string
  avatarId: string
  role: string
  firstName: string
  lastName: string
  email: string
  telephone: string
  marketing: boolean
  status: string
  createdAt: string
}

interface AuthState {
  isAuthenticated: boolean
  user: User | null
  isLoading: boolean
  error: string | null

  // Actions
  logout: () => void
  endLoading: () => void
  fetchUserData: () => Promise<void>
  clearErrors: () => void
}

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      isLoading: false,
      error: null,

      logout: () => {
        void logoutService()
        Cookies.remove('jwt')
        set({ isAuthenticated: false, user: null })
      },

      endLoading: () => set({ isLoading: false }),

      fetchUserData: async () => {
        set({ isLoading: true })
        try {
          const response = await userDetailsService()
          if (response.status !== 200) {
            set({
              isLoading: false,
              isAuthenticated: false,
              user: null
            })
            return
          }
          set({
            isAuthenticated: true,
            user: response.data as User,
            isLoading: false
          })
        } catch (error) {
          set({
            isLoading: false,
            error: error instanceof Error ? error.message : 'Fetch user data failed'
          })
        }
      },
      clearErrors: () => set({ error: null })
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user
      })
    }
  )
)

export default useAuthStore
